import React from "react";
import { Typography, Link } from "@mui/material";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";

export default function Copyright() {
	return (
		<Typography
			variant="body2"
			color="textSecondary"
			align="center"
			sx={{ mt: 4 }}
		>
			{`${process.env.APP_NAME} - Powered by `}
			{/* {"Copyright © "} */}
			<ElectricalServicesIcon
				sx={{ verticalAlign: "middle", display: "inline-flex" }}
			/>
			<Link
				color="inherit"
				href="https://www.digitalforindustry.com/"
				underline="hover"
			>
				{" "}
				Digital For Industry
			</Link>{" "}
			{new Date().getFullYear()}
			{"."}
		</Typography>
	);
}
